import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-indicator-paused",
  "use": "icon-indicator-paused-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-indicator-paused\"><path d=\"M14 24V8c0-.795 0-4-3-4S8 7.205 8 8v16c0 .795 0 4 3 4s3-3.205 3-4M24 24V8c0-.795 0-4-3-4s-3 3.205-3 4v16c0 .795 0 4 3 4s3-3.205 3-4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol